import EventsEngine from '../engines/EventsEngine'
import Helper from '../helpers/Helper'

class HttpClientClass {
    post = async <T>(url: string, body: any, headers?: HeadersInit, onError?: (response: Response) => void): Promise<T> => {
        if (Helper.isDev()) console.log('API (post):', url)
        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: headers
            })

            if (!response.ok) {
                if (response.status === 401) {
                    EventsEngine.publish('auth:unauthorized')
                }
                if (onError) {
                    onError(response)
                } else {
                    const res = await response.json()
                    throw new Error(res?.errorText ?? 'An error occurred on POST.')
                }

                const res = await response.json()
                throw new Error(res?.errorText ?? 'An error occurred on POST.')
            } else {
                return await response.json()
            }
        } catch (error) {
            throw new Error(error.message ?? 'An error occurred on POST.')
        }
    }

    get = async <T>(url: string, headers?: HeadersInit): Promise<T> => {
        if (Helper.isDev()) console.log('API (get):', url)

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            })

            if (!response.ok) {
                const res = await response.json()
                throw new Error(res?.errorText ?? 'An error occurred on GET.')
            } else {
                return await response.json()
            }
        } catch (error) {
            throw new Error(error.message ?? 'An error occurred on GET.')
        }
    }

    postBlob = async (url: string, body: any, headers?: HeadersInit): Promise<Blob> => {
        if (Helper.isDev()) console.log('API (postBlob): ', url)

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: headers
            })

            if (!response.ok) {
                const res = await response.text()
                throw new Error (`Failed to fetch PDF: ${res}`)
            }
            return await response.blob()
        } catch (error) {
            throw new Error(error.message ?? 'An error occurred on POST blob')
        }
    }
}

const HttpClient = new HttpClientClass()
export default HttpClient
